<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_staffs')">
      <router-link class="btn btn-success" :to="{ name: 'staff_create' }" tag="button">
        {{ $t('routes_staffs_create') }}
      </router-link>
    </div>
    <div class="card">
      <lazy-table v-model="staffs" model="staffs" ref="table" :params="query">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ $t('name') }}</th>
              <th>{{ $t('email') }}</th>
              <sortable-th v-model="query.sort" sort_key="user_group.name">{{ $t('user_group') }}</sortable-th>
              <sortable-th v-if="can('read_organizations')" v-model="query.sort" sort_key="organization.name">
                {{ $t('organization') }}
              </sortable-th>
              <sortable-th v-model="query.sort" sort_key="created_at">{{ $t('created_at') }}</sortable-th>
            </tr>
          </thead>
          <tbody v-for="(staffs, organizationName) in grouped">
            <tr>
              <td>
                <strong>{{ organizationName }}</strong>
              </td>
            </tr>
            <router-link
              :to="{ name: 'staff', params: { staff_id: staff.id } }"
              tag="tr"
              v-for="staff in staffs"
              :key="staff.id"
              role="button"
            >
              <td>{{ staff.first_name + ' ' + staff.last_name }}</td>
              <td>{{ staff.email }}</td>
              <td>
                <span v-if="staff.user_group">{{ staff.user_group.name }}</span>
              </td>
              <td v-if="can('read_organizations')">
                <span v-if="staff.organization"> {{ staff.organization.name }}</span>
              </td>
              <td>{{ staff.created_at | datetime }}</td>
            </router-link>
          </tbody>
        </table>
      </lazy-table>
    </div>
  </with-actions>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      query: {
        sort: null,
        limit: 100,
        include: 'user_group,organization'
      },
      staffs: []
    };
  },
  computed: {
    grouped() {
      return _.groupBy(this.staffs, (s) => s.organization.name);
    }
  },
  watch: {
    query: {
      handler() {
        this.$refs.table.load_debounce(true);
      },
      deep: true
    }
  },
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'staffs' }, text: 'Staff accounts' }]);
  }
};
</script>
